


import React from 'react'
import './Partner.css'





const Partner:React.FC = () => {




  return (
   <>


<div className=' w-screen overflow-hidden p-10 custom-partner-container'>
            <div className=' flex flex-col items-center justify-center mx-auto max-w-[800px]'>
                <div className=' sm:text-lg md:text-xl lg:text-3xl xl:text-4xl  text-black font-sans '>
                    <h3>Partner Organizations</h3>
                    </div>

                    <div className=' sm:text-md md:text-lg lg:text-lg xl:text-lg text-black text-center font-mono w-[70%] mt-10'>
                        <p>We collaborate with other nonprofits, training academies,
                             and schools to maximize our impact. Let’s build together.</p>
                    </div>

            </div>
        </div>
 
 
   
   
   
   
   
   
   
   
   </>
  )
}





export default Partner
